export const pendConstants = {
	GET_PEND_REQUEST: "GET_PEND_REQUEST",
	GET_PEND_SUCCESS: "GET_PEND_SUCCESS",
	GET_PEND_ERROR: "GET_PEND_ERROR",

	GET_PEND_LIST_REQUEST: "GET_PEND_LIST_REQUEST",
	GET_PEND_LIST_SUCCESS: "GET_PEND_LIST_SUCCESS",
	GET_PEND_LIST_ERROR: "GET_PEND_LIST_ERROR",

	SET_PAGING_PEND_DETAILS: "SET_PAGING_PEND_DETAILS",

	GET_PEND_HISTORY_REQUEST: "GET_PEND_HISTORY_REQUEST",
	GET_PEND_HISTORY_SUCCESS: "GET_PEND_HISTORY_SUCCESS",
	GET_PEND_HISTORY_ERROR: "GET_PEND_HISTORY_ERROR",

	SET_PAGING_PEND_HISTORY: "SET_PAGING_PEND_HISTORY",
};
